<div class="relative inline-block">
    <div *ngIf="mode === 'determinate'">
        <mat-spinner
            class="determinate"
            [diameter]="diameter"
            [strokeWidth]="strokeWidth"
            [mode]="mode"
            [value]="progress"
            [color]="color"
        >
        </mat-spinner>
        <span class="spinner-label">{{ progress }}%</span>
    </div>

    <div *ngIf="mode === 'indeterminate'">
        <mat-spinner [diameter]="diameter" [strokeWidth]="strokeWidth" [mode]="mode" [color]="color"></mat-spinner>
    </div>
</div>
